import Sidebar from "sidebar/Sidebar";
import Message from "base/Message";

class RevisionSidebar extends Sidebar {

    /**
     * @param loadRevisionsFunc function(page)
     * @param selectRevisionFunc function(revision)
     */
    constructor(loadRevisionsFunc, selectRevisionFunc) {
        super();

        this.loadRevisionsFunc = loadRevisionsFunc;
        this.selectRevisionFunc = selectRevisionFunc;
        this.currentPage = 1;
        this.hasMore = true;

        this.elements = [];
        this.setContent(eotwJSXFactory('div', {class: "admin-sidebar__loading"}));

        this.on("open", () => {
            if (this.currentPage === 1) {
                this.loadMore();
            }
        })
    }

    reload() {
        this.currentPage = 1;
        this.hasMore = true;
        this.elements = [];
        this.setContent(eotwJSXFactory('div', {class: "admin-sidebar__loading"}));

        if (this.isOpen) {
            this.loadMore();
        }
    }

    loadMore() {
        if (this.loadPromise) return this.loadPromise;

        this.loadPromise = Promise.resolve(this.loadRevisionsFunc(this.currentPage)).then((results) => {
            if (results.length === 0) {
                this.loadPromise = Promise.resolve([]);
                this.hasMore = false;
                this.updateList();
            } else {
                this.loadPromise = null;
                this.currentPage++;
                this.elements = this.elements.concat(results);
                this.updateList();
            }
        }).catch(e => {
            console.log(e);
            new Message(e.message, "Couldn't load the revisions")
        });

        this.loadPromise.catch(() => {
            this.loadPromise = null;
        });
    }

    updateList() {
        let $content = eotwJSXFactory('ul', {class: "admin-sidebar__list"}, [
            this.elements.map(result => eotwJSXFactory('li', {class: "admin-sidebar__list__item admin-sidebar__list__item--linked"}, [
                eotwJSXFactory('a', {href: "#", 'data-revision': result.id, class: "js-show-revision admin-sidebar__list__link" + (result.current ? " admin-sidebar__list__item--highlighted" : "") + (result.active ? " admin-sidebar__list__item--selected" : "")}, [
                    eotwJSXFactory('span', {class: "admin-sidebar__list__header"}, [result.name ? [result.date.formatted, eotwJSXFactory('em', null, [" - ", result.name])] : result.date.formatted]),
                    eotwJSXFactory('span', {class: "admin-sidebar__list__subheader"}, [result.user !== null ? result.user.name : "Automated", " ", result.statusText ? eotwJSXFactory('em', null, ["(", result.statusText, ")"]) : [], " ", result.current ? eotwJSXFactory('em', null, ["(Live)"]) : []])
                ])
            ]))
        ]);


        this.setContent($content);
    }

    buildElement() {
        if (this.built) return;
        super.buildElement();

        let $element = this.$element;

        const me = this;
        $element.on('scroll', () => {
            if (!this.hasMore) return;
            if ($element.scrollTop() + $element.height() >= $element.find("ul").outerHeight()) {
                this.loadMore();
            }
        }).on("click", ".js-show-revision", function () {
            Promise.resolve(me.selectRevisionFunc($(this).attr("data-revision"))).then(() => {
                me.updateList();
            });
            return false;
        });

        return $element;
    }
}

export default RevisionSidebar;
